var Scinet = Scinet || {};

Scinet.paperSearch = {
    searchOptions: {
        _options: new Array(),
        get: function () {
            var self = Scinet.paperSearch.searchOptions;
            var result = new Object();
            $.each(self._options, function (index, option) {
                if (option.getResult && $.isFunction(option.getResult)) {
                    var optionValue = option.getResult();
                    result = $.extend(optionValue, result);
                }
            });

            return result;
        },
        register: function (option) {
            this._options.push(option);
        }
    },

    process: function () {
        var self = Scinet.paperSearch;

        if (Scinet.busy) Scinet.busy.lock();

        var options = self.searchOptions.get();

        location.href = $(".search-control").data("url") + "?" + $.param(options, true);
    },

    init: function () {
        var self = Scinet.paperSearch;

        $.each(self.searchOptions._options, function (index, option) {
            if (option.init && $.isFunction(option.init)) {
                option.init(self);
            }
        });
    }
};

Scinet.paperSearch.searchOptions.register({
    searchInput: ".search-control",
    searchButton: ".search-btn",
    clearSearch: ".clear-search-string",
    getResult: function () {
        var result = new Object();
        var searchString = $(this.searchInput).val();
        if (searchString && searchString.length && searchString.length > 0) {
            result.searchString = $.trim(searchString);
        }
        return result;
    },
    init: function (search) {
        var searchControl = $(this.searchInput);
        searchControl.on("keypress", function (e) {
            if (e.which == 13) {
                e.preventDefault();
                search.process();
            }
        });
        $(this.searchButton).on("click", function () {
            search.process();
        });
        $(this.clearSearch).on("click", function () {
            searchControl.val("");
            search.process();
        });
    }
});

Scinet.paperSearch.searchOptions.register({
    journalCheckbox: ".select-journal",
    clearJournal: ".clear-journal",
    getResult: function () {
        var result = new Object();
        result.Journals = new Array();
        var journalCheckBoxes = $(this.journalCheckbox);
        journalCheckBoxes.each(function (index, selector) {
            var $checkbox = $(selector);
            if ($checkbox.is(":checked")) {
                var id = $checkbox.val();
                result.Journals.push(id);
            }
        });
        return result;
    },
    init: function (search) {
        var checkbox = $(this.journalCheckbox);

        checkbox.on("change", function (e) {
            e.preventDefault();
            search.process();
        });

        $(this.clearJournal).on("click", function (e) {
            e.preventDefault();
            var journalId = $(this).data("key");
            checkbox.each(function (index, cb) {
                var $checkbox = $(cb),
                    cbJournalId = $checkbox.val();
                if (cbJournalId == journalId) {
                    $checkbox.removeAttr("checked");
                    search.process();
                }
            });
        });
    }
});

Scinet.paperSearch.searchOptions.register({
    openAccessSelector: "#open-access-papers",
    getResult: function () {
        var result = new Object();
        var checkbox = $(this.openAccessSelector);
        var openAccess = checkbox.length !== 0 && checkbox.is(":checked");
        if (openAccess === true) { //we should include openAccess only if the flag have been selected (see SearchModel.cs, method IsEmpty())
            result.OpenAccess = openAccess;
        }
        return result;
    },
    init: function (search) {
        var checkbox = $(this.openAccessSelector);

        if (checkbox.length !== 0) {
            checkbox.on("change", function (e) {
                e.preventDefault();
                search.process();
            });
        }
    }
});

Scinet.paperSearch.searchOptions.register({
    experimentalSearchSelector: "#experimental-search",
    getResult: function () {
        var result = new Object();
        var checkbox = $(this.experimentalSearchSelector);
        var experimentalSearch = checkbox.length !== 0 && checkbox.is(":checked");
        if (experimentalSearch === true) {
            result.ExperimentalSearch = experimentalSearch;
        }
        return result;
    },
    init: function (search) {
        var checkbox = $(this.experimentalSearchSelector);

        if (checkbox.length !== 0) {
            checkbox.on("change", function (e) {
                e.preventDefault();
                search.process();
            });
        }
    }
});

Scinet.paperSearch.searchOptions.register({
    allPapersSelector: "#publication-type-papers",
    getResult: function () {
        var result = new Object();
        debugger;
        console.log();
        var radio = $(this.allPapersSelector);

        if (radio.is(":checked")) {
            result.PublicationType = radio.val();
        }
        return result;
    },
    init: function (search) {
        var checkbox = $(this.allPapersSelector);

        checkbox.on("change", function (e) {
            e.preventDefault();
            search.process();
        });
    }
});

Scinet.paperSearch.searchOptions.register({
    titlesSelector: "#publication-type-titles",
    getResult: function () {
        var result = new Object();
        debugger;
        console.log();
        var radio = $(this.titlesSelector);

        if (radio.is(":checked")) {
            result.PublicationType = radio.val();
        }
        return result;
    },
    init: function (search) {
        var radio = $(this.titlesSelector);

        radio.on("change", function (e) {
            e.preventDefault();
            search.process();
        });
    }
});

Scinet.paperSearch.searchOptions.register({
    allSelector: "#publication-type-all",
    getResult: function () {
        var result = new Object();
        debugger;
        console.log();
        var radio = $(this.allSelector);

        if (radio.is(":checked")) {
            result.PublicationType = radio.val();
        }
        return result;
    },
    init: function (search) {
        var radio = $(this.allSelector);

        radio.on("change", function (e) {
            e.preventDefault();
            search.process();
        });
    }
});

Scinet.paperSearch.searchOptions.register({
    isByDateSelector: "#date-radio",
    isByRelevanceSelector: "#relevance-radio",

    getResult: function () {
        var result = new Object();
        var checkbox = $(this.isByDateSelector);
        result.SortBy = 0; //By Relevance
        if (checkbox.is(":checked")) {
            result.SortBy = 1; //By Date
        }
        return result;
    },
    init: function (search) {
        function changed(e) {
            search.process();
        };

        $(this.isByDateSelector).on("change", changed);
        $(this.isByRelevanceSelector).on("change", changed);
    }
});

Scinet.paperSearch.searchOptions.register({
    yearSelector: "#Age",
    clearAge: ".clear-year-list",
    getResult: function () {
        var result = new Object();
        var yearSelect = $(this.yearSelector);
        var selectedOption = $("option:selected", yearSelect);
        if (selectedOption) {
            result.age = selectedOption.val();
        }
        return result;
    },
    init: function (search) {
        var $yearSelector = $(this.yearSelector);
        $yearSelector.on("change", function (e) {
            search.process();
        });
        $(this.clearAge).on("click", function (e) {
            $yearSelector.val([]); //To deselect all options in a documented, cross-browser manner use either
            search.process();
        });
    }
});

Scinet.paperSearch.searchOptions.register({
    savedSearchSelector: "#saved-search-id",
    getResult: function () {
        var result = new Object();
        var savedSearchControl = $(this.savedSearchSelector);
        if (savedSearchControl && savedSearchControl.length && savedSearchControl.length > 0) {
            result.ssid = savedSearchControl.val();
        }
        return result;
    }
});


Scinet.paperSearch.searchOptions.registerPhraseOptions = function (inputSelector, addButtonSelector, prevoiusPhraseSelector, clearPhraseSelector, resultFunc) {
    var searchOptions = Scinet.paperSearch.searchOptions;
    var options = {
        keywordInput: inputSelector,
        keywordAddButton: addButtonSelector,
        previousKeyword: prevoiusPhraseSelector,
        clearKeyword: clearPhraseSelector,
        getNewKeyword: function () {
            var newKeyword = $(this.keywordInput).val();
            if (newKeyword && newKeyword.length && newKeyword.length > 0) {
                return $.trim(newKeyword);
            }
            return "";
        },
        setResult: resultFunc,
        getResult: function () {

            var keywords = new Array();
            $(this.previousKeyword).each(function (index, item) {
                keywords.push($(item).val());
            });
            var newKeyword = this.getNewKeyword();
            if (newKeyword.length > 0) {
                keywords.push(newKeyword);
            }

            return this.setResult(keywords);
        },
        init: function (search) {
            var self = this;
            $(this.keywordAddButton).on("click", function () {
                var newKeyword = self.getNewKeyword();
                if (newKeyword.length > 0) {
                    search.process();
                }
            });

            $(this.keywordInput).on("keypress", function (e) {
                if (e.which == 13) {
                    e.preventDefault();
                    $(self.keywordAddButton).trigger("click");
                }
            });

            $(this.clearKeyword).on("click", function (e) {
                var keyword = $(this).data("key");
                $(self.previousKeyword).each(function (index, control) {

                    var $control = $(control),
                        previousKeyword = $control.val();

                    if (keyword == previousKeyword) {
                        $control.detach();
                    }
                });
                search.process();
            });
        }
    };

    searchOptions.register(options);
}

Scinet.paperSearch.searchOptions.registerPhraseOptions(
    "#new-keyword",
    ".add-keyword",
    ".previous-keyword",
    ".clear-keyword",
    function (array) {
        var result = new Object();
        result.keywords = array;
        return result;
    });

Scinet.paperSearch.searchOptions.registerPhraseOptions(
    "#new-author",
    ".add-author",
    ".previous-author",
    ".clear-author",
    function (array) {
        var result = new Object();
        result.authors = array;
        return result;
    });

Scinet.paperSearch.searchOptions.registerPhraseOptions(
    "#new-title",
    ".add-title",
    ".previous-title",
    ".clear-title",
    function (array) {
        var result = new Object();
        result.titles = array;
        return result;
    });

$(function () {
    Scinet.paperSearch.init();
});
